export const ADD_RECENT_PRODUCT_TO_STATE =
  'ADD_RECENT_PRODUCT_TO_STATE' as const;
export const PRODUCTS_TO_SHOW_BY_INDEX = 19;
export const SET_INITIAL_STATE = 'SET_INITIAL_STATE' as const;

export const STORAGE_KEY = 'recentlyViewed';
